import { TJobseekerLedgerListItemDto } from "@/api/services/main/talent-ledger/dtos/get-jobseeker-ledger-list.dto";
import { TJobseekerLedgerRow } from "@/features/management-ledger/types/management-ledger";
import { ECaseMatchStatus } from "@/types/enum";
import { dayjs } from "@/utils/dayjs";
const HIRED_STATUSES: ECaseMatchStatus[] = [ECaseMatchStatus.OFFER_ACCEPTED, ECaseMatchStatus.ALREADY_HIRED];
const REJECTED_STATUSES: ECaseMatchStatus[] = [
    ECaseMatchStatus.FAILED,
    ECaseMatchStatus.CANDIDATE_WITHDRAWN,
    ECaseMatchStatus.OFFER_CANCELLED,
    ECaseMatchStatus.SELECTION_CANCELLED,
];
const getHiringResult = (status: number | null): string => {
    if (status == null)
        return "";
    if (HIRED_STATUSES.includes(status))
        return "採用";
    if (REJECTED_STATUSES.includes(status))
        return "不採用";
    return "";
};
const formatDate = (date: string | null): string => (date ? dayjs(date).format("YYYY/MM/DD") : "");
const buildJobseekerInfo = (dto: TJobseekerLedgerListItemDto): string => {
    const fullAddress = `${dto.prefecture ?? ""}${dto.city ?? ""}${dto.address ?? ""}`;
    return `①${dto.jobseekerName ?? ""}\n②${fullAddress}\n③${formatDate(dto.birthday)}`;
};
const buildEmployerAddress = (dto: TJobseekerLedgerListItemDto): string => `${dto.companyZipCode ?? ""}${dto.companyPrefecture ?? ""}${dto.companyCity ?? ""}${dto.companyAddress ?? ""}`;
export const transformJobseekerLedgerDtoToRow = (dto: TJobseekerLedgerListItemDto): TJobseekerLedgerRow => ({
    talentId: dto.talentId,
    caseMatchId: dto.caseMatchId,
    talentRowSpan: 1,
    jobseekerInfo: buildJobseekerInfo(dto),
    desiredOccupation: dto.desiredOccupation ?? "",
    receptionDate: formatDate(dto.receptionDate),
    validPeriod: formatDate(dto.validPeriod),
    referralDate: formatDate(dto.referralDate),
    jobManagementNo: dto.managementNumber ?? "",
    employerName: dto.companyName ?? "",
    employerAddress: buildEmployerAddress(dto),
    hiringResult: getHiringResult(dto.caseMatchStatus),
    hiredDate: formatDate(dto.hiredDate),
    employmentPeriod: dto.referralEmploymentPeriod ?? null,
    permanentEmploymentNote: dto.permanentEmploymentNote ?? "",
    separationStatusNote: dto.separationStatusNote ?? "",
    remarks: dto.remarks ?? "",
});
export const assignTalentRowSpans = (rows: TJobseekerLedgerRow[]): TJobseekerLedgerRow[] => {
    let groupStart = 0;
    for (let i = 1; i <= rows.length; i++) {
        if (i === rows.length || rows[i].talentId !== rows[groupStart].talentId) {
            const span = i - groupStart;
            rows[groupStart].talentRowSpan = span;
            for (let j = groupStart + 1; j < i; j++)
                rows[j].talentRowSpan = 0;
            groupStart = i;
        }
    }
    return rows;
};
